import PropTypes from 'prop-types';
import { fitDisplaySize } from '@/lib/homepage/format';

/**
 * The heading band for inner pages: an eyebrow, a big display title, a lede,
 * and (optionally) figures or controls below. It ends on a torn ticket edge.
 */
export default function PageHead({ eyebrow, title, lede, children }) {
  return (
    <header className="page-head">
      <div className="max-w-[1520px] mx-auto px-[var(--gutter)] pt-[clamp(2.5rem,6vw,5rem)] pb-[clamp(2.75rem,5vw,4.25rem)]">
        {eyebrow && <p className="font-semibold text-accent-bright">{eyebrow}</p>}
        <h1
          className="d mt-3 -ml-[0.03em] max-w-[14ch]"
          style={{
            fontSize:
              typeof title === 'string' ? fitDisplaySize(title, 'var(--t-loud)') : undefined,
          }}
        >
          {title}
        </h1>
        {lede && (
          <p className="mt-5 max-w-[46ch] text-[length:var(--t-lede)] leading-[1.45] text-muted-foreground">
            {lede}
          </p>
        )}
        {children && <div className="mt-8 lg:mt-12">{children}</div>}
      </div>
    </header>
  );
}

PageHead.propTypes = {
  eyebrow: PropTypes.node,
  title: PropTypes.node.isRequired,
  lede: PropTypes.node,
  children: PropTypes.node,
};
